import React from "react";
import { Card, Button, Container, Row, Col, ListGroup } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

const SubscriptionCheckout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { sub_product, subscriptionData } = location.state || {};

  if (!sub_product || !subscriptionData) {
    return <div className="text-center mt-5">No subscription data available.</div>;
  }

  const handleConfirmSubscription = () => {
    // You can send this to Firebase or any backend
    console.log("Subscription Order Placed", {
      sub_product,
      subscriptionData,
    });

    alert("Subscription order placed successfully!");
    navigate("/");
  };

  const renderDates = () => {
    if (subscriptionData.type === "daily") {
      return <li>Daily Subscription starting from {new Date(subscriptionData.startDate).toLocaleDateString()}</li>;
    } else if (subscriptionData.type === "alternate") {
      return subscriptionData.alternateDates.map((date, i) => (
        <li key={i}>{new Date(date).toLocaleDateString()}</li>
      ));
    } else if (subscriptionData.type === "weekly") {
      return subscriptionData.selectedWeekdays.map((day, i) => <li key={i}>{day}</li>);
    }
  };

  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="p-3 shadow">
            <h3 className="mb-3">Subscription Checkout</h3>
            <Row>
              <Col md={4}>
                <img src={sub_product.image} className="img-fluid" alt={sub_product.title} />
              </Col>
              <Col md={8}>
                <h5>{sub_product.title}</h5>
                <p><strong>Price:</strong> ₹{sub_product.price}</p>
                <p><strong>Subscription Type:</strong> {subscriptionData.type}</p>
                <ListGroup variant="flush">
                  {renderDates()}
                </ListGroup>
              </Col>
            </Row>
            <div className="text-end mt-4">
              <Button variant="primary" onClick={handleConfirmSubscription}>
                Place Subscription Order
              </Button>
            </div>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SubscriptionCheckout;
